/* RESPONSIBLE TEAM: team-frontend-tech */
import relativeTime from 'embercom/lib/relative-time';

let abbreviatedRelativeTimeAgo = function (dateString) {
  return relativeTime(dateString, 'en-abbreviated-relative-time-ago');
};

export default abbreviatedRelativeTimeAgo;
